<template>
  <div
    v-if="feed"
    class="feed-row"
    :class="`${deviceClass} ${feed.feed_state}`"
  >
    <div class="feed-title">
      <div class="feed-name">
        <span class="feed-id">{{ feed.id }}. </span>
        <span>{{ feed.title }}</span>
      </div>
      <FeedState class="ml-1" :state="feed.feed_state" />
    </div>

    <div class="feed-actions ml-1">
      <div class="actions-group mr-1">
        <el-tooltip
          class="item"
          effect="dark"
          placement="top-start"
          content="Edit feed"
        >
          <router-link
            :to="`/integrations/${feed.feed_format_id}/feeds/${feed.id}/edit`"
          >
            <el-button
              type="success"
              plain
              circle
              size="small"
              icon="EditElementIcon"
              class="small-action-btn mr-02"
            />
          </router-link>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          placement="top-start"
          content="History"
        >
          <router-link :to="`/history/Feed/${feed.id}`">
            <el-button
              type="info"
              plain
              circle
              size="small"
              icon="TimerElementIcon"
              class="small-action-btn mr-02"
            />
          </router-link>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          placement="top-start"
          content="Clone feed"
        >
          <router-link
            :to="`/integrations/${feed.feed_format_id}/feeds/${feed.id}/clone`"
            title="Clone"
          >
            <el-button
              type="primary"
              plain
              circle
              size="small"
              icon="CopyDocumentElementIcon"
              class="small-action-btn"
            />
          </router-link>
        </el-tooltip>
        <el-tooltip
          v-if="showDelete"
          class="item"
          effect="dark"
          placement="top-start"
          content="Delete"
        >
          <span>
            <el-popconfirm
              confirm-button-text="OK"
              cancel-button-text="No, Thanks"
              confirm-button-type="danger"
              icon="InfoFilledElementIcon"
              icon-color="red"
              :title="`Are you sure to delete '${feed.title}'?`"
              @confirm="invoke('destroy')"
            >
              <template #reference>
                <el-button
                  type="danger"
                  plain
                  circle
                  size="small"
                  icon="DeleteElementIcon"
                  class="small-action-btn mr-02"
                />
              </template>
            </el-popconfirm>
          </span>
        </el-tooltip>
      </div>
      <div class="actions-group mr-1">
        <PossibleActionButton
          v-for="event in feed.possible_events"
          :key="event"
          :event="event"
          @invoke="invoke"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useFeedsStore } from '@/store/modules/feeds'
import useResize from '@/hooks/useResize'
import FeedState from '@/apps/traforama/views/integrations/components/FeedState.vue'
import PossibleActionButton from '@/apps/traforama/components/PossibleActionButton.vue'

export default defineComponent({
  name: 'IntegrationRow',
  components: {
    FeedState,
    PossibleActionButton
  },
  props: {
    feedId: {
      type: String,
      required: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const feedsStore = useFeedsStore()
    const feed = computed(() => {
      const feed = feedsStore.items[props.feedId]
      return feed?.attributes
    })

    const invoke = async (event: string) => {
      let result
      switch (event) {
        case 'destroy':
          result = await feedsStore.DestroyItem(props.feedId)
          break
        default:
          result = await feedsStore.ChangeState({
            id: props.feedId,
            event: event
          })
      }
    }

    const { deviceClass } = useResize()

    return { feed, deviceClass, invoke }
  }
})
</script>

<style lang="scss" scoped>
.mr-1 {
  margin-right: 1em;
}
.feed-actions {
  display: table;
}

.actions-group {
  float: right;
}

.mobile .campaign-actions {
  display: flex;
  margin-top: 0.5em;
  justify-content: flex-end;
}

.small-action-btn {
  margin-right: 3px;
}

.feed-title {
  display: table;
  .mr-1 {
    margin-right: 1em;
  }
}

.feed-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid var(--el-border-color-light);
  &:last-child {
    border-bottom: none;
  }
  &.paused {
    .feed-name {
      color: var(--el-text-color-secondary);
    }
  }
}

.feed-title {
  display: flex;
}

.feed-id {
  color: var(--el-text-color-secondary);
  font-size: 10px;
}
.el-button--mini {
  padding: 7px 5px;
}
.feed-name {
  font-size: 12px;
  line-height: 2;
}

@media (max-width: 550px) {
  .mobile .feed-title {
    flex-direction: column;
    display: flow-root;
    .feed-name {
      margin: 0.5em;
      padding-right: 0.1em;
    }
  }
  .mobile .feed-actions {
    flex-direction: column;
    margin-top: 0.5em;
    justify-content: flex-end;
    .el-button-group {
      margin-bottom: 0.5em;
    }
  }
  .feed-row {
    &.mobile {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
